<template>
  <div class="tag-anchor" :style="styles" :id="false">
    <div class="tag-anchor__pos" :class="`tag-anchor__pos--tail-${tailPosition}`">
      <div 
        class="tag-basic"
        :class="`tag-basic--tail-${tailPosition}`"
        :id="_id"
        ref="el"
        v-html="label[lang]"
      >
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: ['pos', 'label', 'type', 'tail-position', 'lang', '_id', 'id'],

  computed: {
    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  z-index: 5;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3(top, null, $basic-tag-bg-color)
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3(bottom, null, $basic-tag-bg-color)
    }
  }
}

.tag-basic {
  background-color: $basic-tag-bg-color;
  border-radius: $basic-tag-border-radius;
  box-shadow: $tag-box-shadow;
  color: $basic-tag-font-color;
  cursor: grab;
  font-family: $touchscreen-font;
  font-size: $basic-tag-font-size;
  letter-spacing: .05em;
  line-height: 1.2em;
  width: max-content;
  padding: 0.4em 0.8em 0.5em;
  pointer-events: auto;
  position: absolute;
  user-select: none;
  z-index: 5;

  &--tail-top-left {
    left: -$basic-tag-font-size;
    top: 1em / $basic-tag-font-size + em;
  }

  &--tail-top-center {
    left: 50%;
    top: 1em / $basic-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: -$basic-tag-font-size;
    top: 1em / $basic-tag-font-size + em;
  }

  &--tail-bottom-left {
    left: -$basic-tag-font-size;
    bottom: 1em / $basic-tag-font-size + em;
  }

  &--tail-bottom-center {
    left: 50%;
    bottom: 1em / $basic-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    right: -$basic-tag-font-size;
    bottom: 1em / $basic-tag-font-size + em;
  }
}
</style>
